import React from 'react';
import { Divider } from 'antd';
import {
 Content,
 Head,
 ConnectName,
 Text,
 Title,
 DeviceName,
 NumberDevice,
} from '../../ModalStyled.styled';
import { ErrorIcon } from './../../../../_assests';

export default function NotAcceptedWarning({
 connectName,
 confirmError,
 data,
}) {
 //sessionStorage.removeItem('isSecondProcess');

 const checkNumberDevice = data?.filter((item, idx) => {
  if (confirmError) {
   return item;
  }
  return null;
 });

 return (
  <Content>
   <Head>
    <ErrorIcon />
    <Title>Показания не приняты</Title>
   </Head>
   <Divider />
   {checkNumberDevice.map((item) => {
    if (item.priceFare === null || item.priceFare === 0) {
     return null;
    } else {
     return (
      <>
       <ConnectName>{connectName}</ConnectName>
       <DeviceName>Заводской номер прибора учета</DeviceName>
       <NumberDevice>{item.meteringDeviceNumber}</NumberDevice>
       <Text>
        {confirmError
         ? confirmError
         : 'Показания не приняты к расчету. Обратитесь в справочную службу.'}
       </Text>
      </>
     );
    }
   })}
  </Content>
 );
}
